export default __webpack_public_path__ + "static/media/contour-explain.00defcff.svg";